module.exports = __webpack_public_path__ + "img/icon-plan-map.2e87c506.svg";